import api from 'api'

export type LinkIndeedFlexLocationParams = {
  ifClientId: number
  ifVenueId: number
  companyLocationId: number
}

export type LinkIndeedFlexLocationResponse = {
  id: number
}

export const linkIndeedFlexLocation = async (
  params: LinkIndeedFlexLocationParams
): Promise<LinkIndeedFlexLocationResponse> => {
  const result = await api.post<LinkIndeedFlexLocationResponse>(
    '/admin/indeed_flex/locations/link',
    params
  )
  return result.data
}
